export class SearchRoleFilter {
    pageIndex = 0;
    pageSize = 10;
    keyWord = '';
    getForSetup = true;
    excludeAdminRoles = false;
  }
  